var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTurkeyFlagIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 18,
    viewBox: "0 0 24 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_611_8434)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 18,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-4 -3V21H28V-3H-4Z",
    fill: "#E31D1C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0204 8.7591C10.0048 10.871 11.3529 12.3117 13.0741 12.7357C14.7953 13.1597 16.6821 12.0161 16.6821 12.0161C16.461 12.671 15.3212 14.3458 13.0711 14.3495C10.2643 14.3542 7.07299 12.324 7.0994 8.7591C7.12488 5.32053 10.0804 3.07207 12.8529 3.06742C14.3424 3.06493 16.1592 3.93221 16.6821 5.16671C16.6821 5.16671 15.0163 4.20646 13.1241 4.65882C11.232 5.11118 10.0351 6.78219 10.0204 8.7591Z",
    fill: "#F7FCFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4534 6.33976L16.0105 6.60715L16.1115 6.08537L15.7427 5.69486L16.2421 5.67374L16.4534 5.18652L16.6647 5.67374H17.1633L16.7953 6.08537L16.9061 6.60715L16.4534 6.33976Z",
    fill: "#F1F9FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4534 11.2568L16.0105 11.5241L16.1115 11.0024L15.7427 10.6119L16.2421 10.5907L16.4534 10.1035L16.6647 10.5907H17.1633L16.7953 11.0024L16.9061 11.5241L16.4534 11.2568Z",
    fill: "#F1F9FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4534 9.61711L16.0105 9.8845L16.1115 9.36271L15.7427 8.9722L16.2421 8.95109L16.4534 8.46387L16.6647 8.95109H17.1633L16.7953 9.36271L16.9061 9.8845L16.4534 9.61711Z",
    fill: "#F1F9FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4534 7.97843L16.0105 8.24583L16.1115 7.72404L15.7427 7.33353L16.2421 7.31242L16.4534 6.8252L16.6647 7.31242H17.1633L16.7953 7.72404L16.9061 8.24583L16.4534 7.97843Z",
    fill: "#F1F9FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_611_8434"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTurkeyFlagIcon);
export default __webpack_public_path__ + "static/media/turkeyFlagIcon.be698d44f5be149f9dc09b615f4814ba.svg";
export { ForwardRef as ReactComponent };